import { v4 as uuidv4 } from 'uuid';
import React, { useState, useEffect,useRef } from 'react';
import FormLabel from '@mui/material/FormLabel';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Document, Page, Text, StyleSheet, View, Image, PDFDownloadLink, PDFViewer, Font, Svg } from '@react-pdf/renderer';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Slide from '@mui/material/Slide';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { DataGrid } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import ShipmentAdjustments from './ShipmentAdjustments';
import apiClient from '../ApiClient/ApiClient';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Taipei');

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function ToShip({ data }) {
    const [newData, setNewData] = useState(null);
    const [model, setModel] = useState('出貨交運單');
    const [page, setPage] = useState(1);
    const [rows, setRows] = useState([]);
    const [supplementSelection, setSupplementSelection] = useState([]);
    const [supplementChecks, setSupplementChecks] = useState([]);
    const [supplementOpen, setSupplementOpen] = useState(false);
    const [supplementReason, setSupplementReason] = useState('');
    const [createRows, setCreateRows] = useState([]);
    const [orderRows, setOrderRows] = useState([]);
    const [coms, setComs] = useState([]);
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const [selectedDrDate, setSelectedDrDate] = useState(dayjs());
    const [way, setWay] = useState('drawNum');
    const [num, setNum] = useState('');
    const [barCode, setBarCode] = useState('');
    const [isCreate, setIsCreate] = useState(false);
   
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [month, setMonth] = useState("");
    const [detailData, setDetailData] = useState({
        toShipNum: '', // 初始化為空字符串或其他適當的初始值
        toShipKind: '銷貨出庫', // 假設還有其他屬性
        // 添加其他需要的屬性
    });
    // ✅ 新增：搜尋條件統一由父層管理
    const [filterClient, setFilterClient] = useState('');
    const [filterShipNum, setFilterShipNum] = useState('');

    const gridRef = useRef();
    // 開始建立一張全新的出貨交運單。
    const handleRefresh = () => {
        // 尋找預設廠商
        const taiRiOption = options.find(
                (o) => o.manufacturer_Seq === "45000010" || o.manufacturer_AbbreviationName === "台博"
             );
    
        if (taiRiOption) {
            setSelectedOption({
                ...taiRiOption,
                manufacturer_ContactName: "", // 聯絡人設為空
                manufacturer_CompanyPhone: "03-3244711",
                manufacturer_ShipAddress: "桃園縣蘆竹鄉內厝村內溪路29號"
            });
        } else {
            setSelectedOption(null);
        }

        // 不可沿用上一張單據的簽核狀態，否則新增後儲存按鈕仍會被鎖住。
        setDetailData({
            toShipNum: '',
            toShipKind: '銷貨出庫',
            approvalStatus: 'Draft'
        });
        setIsCreate(true);
        setCreateRows([]);
        setRows([]);
        setOrderRows([]);
        setSelectedRow(null);
        setSelectedDate(dayjs());
        setSelectedDrDate(dayjs());
        setNum('');
        setBarCode('');
    };

    useEffect(() => {
        console.log("Month state updated:", month);
    }, [month]);

    const columns = [
        
        { field: '批號', headerName: '批號', width: 115, editable: true },
        { field: '圖號', headerName: '圖號', width: 125, editable: true },
        { field: 'srqty', headerName: '不登錄', width: 60, editable: true },
        { field: '機種', headerName: '機種', width: 60, editable: true },
        { field: '物品名', headerName: '物品名', width: 110, editable: true },
        { field: '訂單數量', headerName: '訂單數量', width: 90, editable: true },
        { field: '實交貨數', headerName: '實交貨數', width: 90, editable: true },
        { field: '單位', headerName: '單位', width: 60, editable: true },
        { field: '訂單號碼', headerName: '訂單號碼', width: 120, editable: true },
        { field: '流水號', headerName: '流水號', width: 60, editable: true },
        { field: '出貨備註', headerName: '出貨備註', width: 110, editable: true },
        { field: 'id', headerName: 'ID', width: 90 },
    ];

    const orderColumns = [
        { field: '批號', headerName: '批號', width: 115 },
        { field: '圖號', headerName: '圖號', width: 125 },
        { field: '項次', headerName: '項次', width: 50 },
        { field: '機種', headerName: '機種', width: 110, editable: true },
        { field: '物品名', headerName: '物品名', width: 110, editable: true },
        { field: '訂單數量', headerName: '訂單數量', width: 80, editable: true },
        {
            field: '未交貨數',
            headerName: '未交貨數',
            width: 90,
            editable: false, // 這個列不需要手動編輯
            valueGetter: (params) => {
                // 計算未交貨數
                const 訂單數量 = params.row.訂單數量 || 0;
                const 實交貨數 = params.row.實交貨數 || 0;
                const 累計交貨數量=params.row.累計交貨數量 || 0;
                return 訂單數量 - 實交貨數 - 累計交貨數量;
            }
        },
        { field: '實交貨數', headerName: '實交貨數', width: 80, editable: true },
        { field: '訂單號碼', headerName: '訂單號碼', width: 105, editable: true },
        { field: '流水號', headerName: '流水號', width: 65, editable: true },
        
        { field: '單位', headerName: '單位', width: 70, editable: true },
        { field: 'memo', headerName: '出貨備註', width: 110, editable: true },
        { field: '承製公司', headerName: '承製公司', width: 110, editable: true },
        {
            field: 'remove',
            headerName: '移除',
            width: 110,
            renderCell: (params) => {
                const onClick = () => {
                    handleRemoveRowRequest(params.row);
                };
                return isCreate ? <button type='button' onClick={onClick}>移除</button> : null;
            }
        },

        { field: 'id', headerName: 'ID', width: 90 },
    ];

    const orderColumnsNoEdit = [
        { field: '批號', headerName: '批號', width: 110 },
        { field: '圖號', headerName: '圖號', width: 112 },
        { field: '項次', headerName: '項次', width: 60 },
        { field: '機種', headerName: '機種', width: 110 },
        { field: '物品名', headerName: '物品名', width: 110 },
        { field: '訂單數量', headerName: '訂單數量', width: 90 },
        {
            field: '未交貨數',
            headerName: '未交貨數',
            width: 90,
            editable: false, // 這個列不需要手動編輯
            valueGetter: (params) => {
                // 計算未交貨數
                const 訂單數量 = params.row.訂單數量 || 0;
                const 實交貨數 = params.row.實交貨數 || 0;
                const 累計交貨數量=params.row.累計交貨數量 || 0;
                return 訂單數量 - 實交貨數 - 累計交貨數量;
            }
        },
        { field: '實交貨數', headerName: '實交貨數', width: 110 },
        { field: '訂單號碼', headerName: '訂單號碼', width: 110 },
        { field: '流水號', headerName: '流水號', width: 70 },     
        { field: '單位', headerName: '單位', width: 110 },
        { field: 'memo', headerName: '出貨備註', width: 110},
        { field: '承製公司', headerName: '承製公司', width: 110 },  
        { field: 'id', headerName: 'ID', width: 90 },
    ];


    const [splitDialogOpen, setSplitDialogOpen] = useState(false); // 控制對話框顯示
    const [splitQuantity, setSplitQuantity] = useState(0); // 儲存分拆數量
    const [selectedRow, setSelectedRow] = useState(null); // 儲存選擇的行資料
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [rowToDelete, setRowToDelete] = useState(null);
    const [postingDialogOpen, setPostingDialogOpen] = useState(false);
    const [postingResults, setPostingResults] = useState([]);
    const [recentCardDialogOpen, setRecentCardDialogOpen] = useState(false);
    const [recentCardDrawNum, setRecentCardDrawNum] = useState('');
    const [recentCards, setRecentCards] = useState([]);
    const isExistingEditMode = isCreate && Boolean(detailData?.toShipNum);

    // 打開分拆對話框
    const handleAccountSharing = (rows) => {
        setSelectedRow(rows); // 設置選中的行
        setSplitDialogOpen(true); // 打開對話框
    };

    // 父元件 ToShip 內
const fetchCom = async (client) => { // ← 原本在 ListTable 的也上移到父元件
    setLoading(true);
    try {
      const res = await apiClient.get(`/ToShip/Comlist?com=${client}`);
      if (res.status === 200) setComs(res.data);
    } finally {
      setLoading(false);
    }
  };
  
  const refreshDetailsByNum = React.useCallback(
    async (toShipNum, client) => {
      if (!toShipNum) return;
      setLoading(true);
      try {
        const { data } = await apiClient.get(`/ToShip/GetMainAndDetails?toShipNum=${toShipNum}`);
        if (data.statusCode === 200) {
          setIsCreate(false);
          setDetailData(data.toShip);
          setRows(data.orderDtos);
          setSelectedDate(dayjs(data.toShip.toShipDate));
          setSelectedDrDate(dayjs(data.toShip.drDate));
  
          // 同步選中客戶
          const matched = options.find(o =>
                     o.manufacturer_Seq === "45000010" ||
                     o.manufacturer_AbbreviationName === data.toShip.client ||
                     o.manufacturer_FullName === data.toShip.client
                   );
          setSelectedOption(matched || null);
  
          // 需要公司清單就呼叫（client 可用 data.toShip.client 做為最新依據）
          await fetchCom(data.toShip.client);
        } else {
          alert('找不到資料');
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    },
    [options] // 依賴 options 即可；其它 setState 不需要放依賴
  );
  

    // 提交分拆
    const handleSplitSubmit = async () => {
        if (!splitQuantity || splitQuantity <= 0) {
            alert('請輸入有效的分拆數量');
            return;
        }

        setLoading(true);
        try {
            const response = await apiClient.get(`/ToShip/Split?toShipNum=${detailData.toShipNum}&id=${selectedRow?.id}&quantity=${splitQuantity}`);

            if (response.status === 200) {
                alert('分拆成功！');
                setSplitDialogOpen(false); // 關閉對話框
                setRows(response.data.orderDtos);
                await refreshDetailsByNum(detailData.toShipNum, selectedOption?.manufacturer_AbbreviationName);
            } else {
                alert('分拆失敗，請稍後再試');
            }
        } catch (error) {
            console.error('分拆失敗:', error);
            alert(error.response?.data?.message || '分拆失敗，請稍後再試');
        }finally{
            setLoading(false);
        }
    };

    // 關閉對話框
    const handleDialogClose = () => {
        setSplitDialogOpen(false);
        setSplitQuantity(0);
        setSelectedRow(null);
    };

    const workMargin = {
        marginTop: '3%',
        marginBottom: '5%'
    };

    const handleRemoveRowRequest = (row) => {
        if (row.isReservation === 1) {
            // 直接從 createRows 移除這一筆（不彈窗）
            setCreateRows(prevCreateRows => prevCreateRows.filter(r => r.id !== row.id));
        } else {
            // 走原本彈窗刪除流程
            setRowToDelete(row);
            setDeleteDialogOpen(true);
        }
    };
    

    const handleConfirmDelete = async () => {
    if (!rowToDelete) return;

    setLoading(true);
    try {
        // 假設你的 API 長這樣，請視後端實際情形調整
        await apiClient.delete(`/ToShip/DeleteRow?id=${rowToDelete.id}`);
        // 從 createRows 移除
        setCreateRows(prevCreateRows => prevCreateRows.filter(row => row.id !== rowToDelete.id));
        setDeleteDialogOpen(false);
        setRowToDelete(null);
    } catch (error) {
        alert(`刪除失敗！${error.response?.data?.message || error.message}`);
    } finally {
        setLoading(false);
    }
};

const handleCancelDelete = () => {
    setDeleteDialogOpen(false);
    setRowToDelete(null);
};


    const setModelandGetDate = (newModel) => {
        setModel(newModel);
    };

    const handleDateChange = (newDate) => {
        setSelectedDate(newDate);
    };

    const handleDrDateChange = (newDate) => {
        setSelectedDrDate(newDate);
    };

    const fetchOrders = async () => {
        setLoading(true);
        try {
            // 使用空字符串作为默认值，如果 selectedOption 是 null 或 undefined
            const client = selectedOption ? selectedOption.manufacturer_AbbreviationName : '';
            const response = await apiClient.get(`/ToShip/Orderlist?client=${client}&num=${num}&way=${way}&barcode=${barCode}`);
            // 检查响应的结果，并设置到 state
            if (response.status === 200) {
                setOrderRows(response.data);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            // 可选：在 UI 中显示错误消息
            // setError('Failed to fetch data. Please try again.');
        }finally{
            setLoading(false);
        }
    };

    const fetchOptions = async () => {
        setLoading(true);
        try {
            const response = await apiClient.get(`/Manufacturer/list`);
            if (response.status === 200) {
                setOptions(response.data.manufacturers);

            // 只設定廠商為「台日」
            const defaultOption = response.data.manufacturers.find(
                       (o) => o.manufacturer_Seq === "45000010" || o.manufacturer_AbbreviationName === "台博"
                     );
            if (defaultOption) {
                setSelectedOption(defaultOption);
            }
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }finally{
            setLoading(false);
        }
    };



const handleAddToShip = (params) => {
    setIsCreate(true);

    const 訂單數量 = params.row.訂單數量 || 0;
    const 實交貨數 = params.row.實交貨數 || 0;
    const 累計交貨數量 = params.row.累計交貨數量 || 0;
    const 未交貨數 = 訂單數量 - 實交貨數 - 累計交貨數量;

    // 取得原訂單的 isReservation
    const reservationValue = params.row.isReservation ?? params.row.IsReservation ?? null;
    // 若 isReservation = 0，只跳警告，但不停止流程
    if (Number(reservationValue) === 0) {
        alert('此筆不可於台博登錄');
    }


    // 先查有沒有相同 id 的 row
    const sameIdRows = createRows.filter(row => row.id === params.row.id);

    if (sameIdRows.length > 0) {
        // 有相同 id，檢查訂單號碼和流水號
        const foundSameOrder = sameIdRows.some(
            row => row.訂單號碼 === params.row.訂單號碼 && row.流水號 === params.row.流水號
        );

        if (foundSameOrder) {
            // 完全重複，不寫入
            return;
        }
        // id 一樣但(訂單號碼,流水號)不同，**寫入新的 row，id 用 uuidv4**
        setCreateRows(prevCreateRows => [
            ...prevCreateRows,
            {
                ...params.row,
                id: uuidv4(),
                chkQty: params.row.id,
                isReservation: 1,
                // 新增：把原資料的 isReservation 寫入 Code1
                Code1: reservationValue == null ? '' : String(reservationValue),
                實交貨數: 未交貨數
            }
        ]);
    } else {
        // 沒有這個 id，直接寫入
        setCreateRows(prevCreateRows => [
            ...prevCreateRows,
            {
                ...params.row,
                isReservation: 1,
                // 新增：把原資料的 isReservation 寫入 Code1
                Code1: reservationValue == null ? '' : String(reservationValue),
                實交貨數: 未交貨數
            }
        ]);
    }

    setOrderRows(prevOrderRows => prevOrderRows.filter(row => row.id !== params.row.id));
};

       

    const handleOptionChange = (event, newValue) => {
        setSelectedOption(newValue);
    };

    const handleSave = async () => {
        const modifiedRows = createRows.map(item => ({
            ...item,
        }));
        console.log(modifiedRows);
        console.log(processRowUpdate);

        if (!selectedOption) {
            alert('請先選擇廠商');
            return;
        }

        if (modifiedRows.length === 0) {
            alert('請先從下方未出貨訂單搜尋資料，並雙擊要加入的明細');
            return;
        }

        const invalidRow = modifiedRows.find(item =>
            !item.圖號 || !item.訂單號碼 || Number(item.實交貨數) <= 0
        );
        if (invalidRow) {
            alert('每筆明細都必須有圖號、訂單號碼，且實交貨數必須大於 0');
            return;
        }

        const formattedDate = dayjs(selectedDate).format('YYYY-MM-DD');
        const formattedDrDate = dayjs(selectedDrDate).format('YYYY-MM-DD');

        // ===== 這裡是修改重點 =====
    // 如果沒有出貨單號才檢查，否則跳過
    if (!detailData.toShipNum) {
        const hasInvalidShipNum = modifiedRows.some(item => item.實交貨數 > item.訂單數量);
        if (hasInvalidShipNum) {
            alert('實交貨數不能大于訂單數量');
            return; // 停止執行更多的代碼
        }
    }

        // 如果沒有問題，繼續執行
        const toShipData = {
            ToShipDate: formattedDate,
            ToDrDate: formattedDrDate,
            Client: selectedOption ? selectedOption.manufacturer_AbbreviationName : '',
            SellWay: detailData.toShipKind,
            Orders: modifiedRows,
            ShipNum: detailData.toShipNum || null
        };
        setLoading(true);
        try {
            const response = await apiClient.post(`/ToShip/OrderToShip`, toShipData);
            if (response.status === 200) {
                const savedShipNum = response.data.shipNum;
                alert(`${detailData.toShipNum ? '變更儲存成功' : '草稿儲存成功'}\n出貨單號: ${savedShipNum}`);
                await refreshDetailsByNum(savedShipNum, selectedOption?.manufacturer_AbbreviationName);
            }
            console.log("單號", detailData.toShipNum); // 這裡可能仍然是舊的值
        } catch (error) {
            alert(`出貨失敗: ${error.response?.data?.message || error.message}`);
            console.error('出貨失敗:', error);
            // 這裡處理錯誤情況，可能需要更新UI來顯示錯誤信息
        }finally{
            setLoading(false);
        }
    };

    React.useEffect(() => {
        setSupplementSelection([]);
        setSupplementChecks([]);
        setSupplementOpen(false);
    }, [detailData?.toShipNum, rows]);

    const checkSupplement = async () => {
        if (!detailData?.toShipNum || supplementSelection.length === 0) {
            alert('請先勾選要查核的出貨明細');
            return;
        }
        setLoading(true);
        try {
            const response = await apiClient.post('/ToShip/CheckSupplement', {
                shipNum: detailData.toShipNum, lineIds: supplementSelection
            });
            setSupplementChecks(response.data?.data || []);
            setSupplementReason('');
            setSupplementOpen(true);
        } catch (error) {
            alert(error.response?.data?.message || '補扣查核失敗');
        } finally { setLoading(false); }
    };

    const executeSupplement = async () => {
        if (!supplementReason.trim() || supplementChecks.some(x => x.status !== '可補扣')) return;
        if (!window.confirm('確認只補扣所列差額？本次沿用原出貨單，不增加訂單累計交貨數量。')) return;
        setLoading(true);
        try {
            const response = await apiClient.post('/ToShip/Supplement', {
                shipNum: detailData.toShipNum,
                lineIds: supplementChecks.map(x => x.lineId),
                reason: supplementReason.trim(),
                expectedQuantities: Object.fromEntries(supplementChecks.map(x => [x.lineId, x.supplementQuantity]))
            });
            const results = response.data?.data || [];
            alert(`${response.data?.message || '作業完成'}\n${results.map(x => `${x.drawNum}：${x.message} 剩餘庫存 ${x.afterStock}`).join('\n')}`);
            await refreshDetailsByNum(detailData.toShipNum, selectedOption?.manufacturer_AbbreviationName);
        } catch (error) {
            setSupplementChecks([]);
            alert(error.response?.data?.message || '補扣失敗，請重新查核');
        } finally { setLoading(false); }
    };

    const handleApprovalAction = async (action) => {
        if (!detailData?.toShipNum) {
            alert('請先儲存出貨交運單草稿');
            return;
        }

        let reason = null;
        if (action === 'Reject') {
            reason = window.prompt('請輸入退回原因');
            if (reason === null) return;
        }
        if (action === 'CancelApproval' && !window.confirm('確定取消已核准的出貨？系統會建立沖回資材卡。')) return;

        setLoading(true);
        try {
            const response = await apiClient.post(`/ToShip/${action}`, {
                shipNum: detailData.toShipNum,
                reason
            });
            const result = response.data?.data;
            const warnings = result?.warnings || [];
            const warningText = warnings.length > 0
                ? `\n\n負庫存警示：\n${warnings.map(x => `${x.drawNum}：${x.beforeStock} - ${x.transactionQuantity} = ${x.afterStock}`).join('\n')}`
                : '';
            alert(`${response.data?.message || '作業完成'}${warningText}`);
            if (action === 'Approve') {
                setPostingResults(result?.postingResults || []);
                setPostingDialogOpen(true);
            }
            await refreshDetailsByNum(detailData.toShipNum, selectedOption?.manufacturer_AbbreviationName);
        } catch (error) {
            alert(error.response?.data?.message || '簽核作業失敗');
        } finally {
            setLoading(false);
        }
    };

    const openRecentMaterialCards = async (drawNum) => {
        if (!drawNum) return;
        setLoading(true);
        try {
            const response = await apiClient.get('/MatCard/RecentByDrawNum', {
                params: { drawNum, months: 2 }
            });
            setRecentCardDrawNum(drawNum);
            setRecentCards(response.data?.data || []);
            setRecentCardDialogOpen(true);
        } catch (error) {
            alert(error.response?.data?.message || '查詢最近兩個月資材卡失敗');
        } finally {
            setLoading(false);
        }
    };

    const loadPostingResults = async () => {
        if (!detailData?.toShipNum) return;
        setLoading(true);
        try {
            const response = await apiClient.get('/ToShip/PostingResults', {
                params: { shipNum: detailData.toShipNum }
            });
            setPostingResults(response.data?.data || []);
            setPostingDialogOpen(true);
        } catch (error) {
            alert(error.response?.data?.message || '查詢出貨過帳結果失敗');
        } finally {
            setLoading(false);
        }
    };

    // 使用 useEffect 監聽 detailData.toShipNum 的變化
    useEffect(() => {
        if (detailData.toShipNum) {
            console.log('useEffect - Updated toShipNum:', detailData.toShipNum);
            console.log('useEffect - Updated detailData:', detailData);
            // 這裡可以添加需要在狀態更新後執行的其他邏輯
        }
    }, [detailData.toShipNum]);

    const handleRowSelection = (params) => {
        console.log("Selected row data:", params.row); // 調試信息
        setSelectedRow(params.row); // 更新選中的行數據
    };

    const handleEnterEdit = () => {
        setIsCreate(true); // 設置為編輯模式
        // 將 rows 的 "出貨備註" 欄位名改成 memo
        const convertedRows = rows.map(row => {
            // 複製 row，並把 memo 設為 出貨備註 的值（如果有的話）
            const { 出貨備註, ...rest } = row;
            return {
                ...rest,
                memo: 出貨備註 || '', // 沒有就給空字串
            };
        });
        setCreateRows(convertedRows); // 設置轉換後的資料
        console.log(convertedRows);
    };

    const handleCancelEdit = async () => {
        if (!detailData?.toShipNum) return;
        if (!window.confirm('確定取消尚未儲存的修改，並重新載入目前已儲存的資料？')) return;

        setCreateRows([]);
        setOrderRows([]);
        setSelectedRow(null);
        await refreshDetailsByNum(detailData.toShipNum, selectedOption?.manufacturer_AbbreviationName);
    };

    const handlePrint = (toShipNum) => {
        if (!toShipNum) {
            alert('出貨單號不存在，無法列印。');
            return;
        }
        setLoading(true);
        apiClient.get(`/ToShip/CreateExcel?num=${toShipNum}`, {
            responseType: 'blob',  // 指定响应类型为 Blob
            headers: {
                'Id': localStorage.getItem('Id')
            }
        })
            .then(response => {
                if (response.data) {
                    // Create a URL for the blob
                     const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

                    // Open the PDF in a new window
                    const newWindow = window.open(url, '_blank');

                     if (!newWindow) {
                        alert('請允許瀏覽器開啟新視窗或關閉彈出式封鎖');
                    }
        
                    // 延遲撤銷 URL，避免 PDF 還沒載入就被釋放
                    setTimeout(() => {
                        window.URL.revokeObjectURL(url);
                    }, 10000); // 等 10 秒再釋放比較保險

                    alert('PDF 文件已開啟');
                } else {
                    alert('列印失败');
                }
            })
            .catch(error => {
                console.error('發生錯誤:', error);
                alert('發生錯誤');
            })
            .finally(()=>{
                setLoading(false);
            });
    };

    const handleExecl = (toShipNum) => {
        if (!toShipNum) {
            alert('出貨單號不存在，無法輸出。');
            return;
        }
        setLoading(true);
        apiClient.get(`/ToShip/CovertToExcel?num=${toShipNum}`, {
            responseType: 'blob',  // 指定响应类型为 Blob
            headers: {
                'Id': localStorage.getItem('Id')
            }
        })
        .then((response) => {
            // 創建 Blob URL
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
    
            // 設定下載檔案的名稱
            link.setAttribute('download', '出貨交運單.xlsx');
    
            // 觸發下載
            document.body.appendChild(link);
            link.click();
    
            // 清除 DOM 中的元素
            link.remove();
            window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
            console.error('下載失敗:', error);
            alert('發生錯誤，無法下載檔案');
        })
        .finally(()=>{
            setLoading(false);
        });
    };
    const processRowUpdate = (newRow, oldRow) => {
        if (isCreate) {
            // 更新 createRows，替換現有行
            setCreateRows(prevCreateRows => 
                prevCreateRows.map(row => row.id === newRow.id ? { ...newRow } : row)
            );
    
            // 如果 '訂單數量' 或 '實交貨數' 發生變化，更新 '未交貨數'
            if (newRow.訂單數量 !== oldRow.訂單數量 || newRow.實交貨數 !== oldRow.實交貨數) {
                return {
                    ...newRow,
                    未交貨數: newRow.訂單數量 - newRow.實交貨數,
                    出貨備註: newRow.出貨備註,
                    isReservation: oldRow.isReservation,
                };
            }
    
            return {
                ...newRow,
                isReservation: oldRow.isReservation  // ✅ 總是保留欄位
            };
        }
    
        // 如果不是 createRows，則更新 rows
        setRows(prevRows => 
            prevRows.map(row => row.id === newRow.id ? { ...newRow } : row)
        );
    
        // 如果 '訂單數量' 或 '實交貨數' 發生變化，更新 '未交貨數'
        if (newRow.訂單數量 !== oldRow.訂單數量 || newRow.實交貨數 !== oldRow.實交貨數) {
            return {
                ...newRow,
                未交貨數: newRow.訂單數量 - newRow.實交貨數,
                出貨備註: newRow.出貨備註,
                isReservation: oldRow.isReservation,
            };
        }
    
        return {
            ...newRow,
            isReservation: oldRow.isReservation
        };
    };
    
    const handleSupplementSubmit = async () => {
        setLoading(true);
        try {
            const response = await apiClient.get(`/ToShip/DefectiveProducts?drawNum=${num}`);
            if (response.status === 200) {
                const validData = response.data.filter(item => item.id); // 過濾掉沒有 ID 的資料
                setOrderRows(validData);
            } else {
                alert('補交資料搜尋失敗');
            }
        } catch (error) {
            alert('補交資料搜尋失敗，請稍後再試。');
            console.error(error);
        }finally{
            setLoading(false);
        }
    };
    
    

    const handleSellChange = (event) => {
        // 更新 detailData 状态，特别是 toShipKind 属性
        setDetailData({
            ...detailData,
            toShipKind: event.target.value,
        });
    };

    useEffect(() => {
        fetchOptions();
    }, []);

    return (
        <>
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
        >
        <CircularProgress color="inherit" />
        </Backdrop>

        <div className='container-fluid'>
        <div className='row' style={{ ...workMargin, minHeight: '24px', alignItems: 'center' }}>
    <div className='col-2 d-flex align-items-center'>
        <h2>
            <span className="badge bg-dark">出貨資料</span>
        </h2>
    </div>
    {/* 搜尋按鈕獨立一格，不跟標籤同 col */}
    <div className='col-1 d-flex align-items-center'>
    <SelectFilter
        setNewData={setNewData}
        setMonth={setMonth}
        setLoading={setLoading}
        filterClient={filterClient}
        setFilterClient={setFilterClient}
        filterShipNum={filterShipNum}
        setFilterShipNum={setFilterShipNum}
    />
    </div>
    {/* <div className='col-1' /> */}
    <div className='col-6 d-flex align-items-center justify-content-start'>
        <h2><span className="badge bg-dark">訂單資料</span></h2>
    </div>
    <div className='col-3 d-flex align-items-center justify-content-end'>
        <Button variant="contained" onClick={handleRefresh}>新增出貨單</Button>
    </div>
</div>

            <div className='row'>
                <div className='col-3'>
                {(newData || data) && model === '出貨交運單' ? (
                        <ListTable
                            setDetailData={setDetailData}
                            setNewData={setNewData}
                            data={newData || data}
                            setModel={setModelandGetDate}
                            page={page}
                            setPage={setPage}
                            setRows={setRows}
                            setComs={setComs}
                            setSelectedDate={setSelectedDate}
                            setSelectedDrDate={setSelectedDrDate}
                            options={options}
                            setSelectedOption={setSelectedOption}
                            setIsCreate={setIsCreate}
                            month={month}  // 確保傳遞 month 作為 props
                            setLoading={setLoading}
                            onOpenDetails={refreshDetailsByNum} 
                            // ✅ 新增
                            filterClient={filterClient}
                            filterShipNum={filterShipNum}
                        />
                    ) : (
                        <div>目前還沒取得資料或取不到資料</div>
                    )}
                </div>
                {/* <div className='col-1' /> */}
                <div className='col-9'>
                    <Box sx={{ height: 600, width: '100%' }}>
                        <Box sx={{ flexGrow: 1 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={3}>
                                    <FormControl fullWidth>
                                    <Autocomplete
                                        disablePortal
                                        disabled={!isCreate}
                                        options={options || []}
                                        value={selectedOption || null}
                                        onChange={(e, newValue) => setSelectedOption(newValue)}
                                        // 用唯一鍵比對即可忽略物件參考不同問題
                                        isOptionEqualToValue={(option, value) =>
                                        !!value && option.manufacturer_Seq === value.manufacturer_Seq
                                         }
                                        // label 可能是 null，保險處理
                                        getOptionLabel={(option) => {
                                            if (!option) return '';
                                            // 如果 option 可能是 string，處理一下
                                                if (typeof option === 'string') return option;
                                                const seq = option.manufacturer_Seq ?? '';
                                                const name = option.manufacturer_AbbreviationName ?? option.manufacturer_FullName ?? '';
                                                return `${seq}${name}`;
                                            }}
                                        renderInput={(params) => <TextField {...params} label="廠商" />}
                                    />
                                        {/* <InputLabel id="demo-simple-select-label">客戶</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={detailData != null ? detailData.client : ''}
                                            onChange={handleClientChange}
                                        >
                                            {coms.map((item) => (
                                                <MenuItem key={item.id} value={item.簡稱}>
                                                    {item.簡稱}
                                                </MenuItem>
                                            ))}
                                        </Select> */}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        id="outlined-basic"
                                        label="出貨單號"
                                        variant="outlined"
                                        value={detailData != null ? detailData.toShipNum : ''}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        label="簽核狀態"
                                        variant="outlined"
                                        value={detailData?.approvalStatus || (detailData?.toShipNum ? 'Draft' : '')}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField id="outlined-basic" label="聯絡人" variant="outlined"
                                        value={selectedOption ? selectedOption.manufacturer_ContactName : ''}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField id="outlined-basic" label="電話" variant="outlined" 
                                        value={selectedOption ? selectedOption.manufacturer_CompanyPhone : '03-3244711'} />
                                </Grid>
                                <Grid item xs={3}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DatePicker']}>
                                            <DatePicker label="出貨日期" value={selectedDate} onChange={handleDateChange} disabled={!isCreate} />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={3}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DatePicker']}>
                                            <DatePicker label="入帳日期" value={selectedDrDate} onChange={handleDrDateChange} disabled={!isCreate} />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={5}>
                                    <TextField id="outlined-basic" label="送貨地址" variant="outlined"  style={{ width: '100%' }}
                                        value={selectedOption ? selectedOption.manufacturer_ShipAddress : '桃園縣蘆竹鄉內厝村內溪路29號'} />
                                </Grid>
                                <Grid item xs={8}>
                                    {isExistingEditMode && (
                                        <Typography sx={{ mb: 1, color: 'warning.main', fontWeight: 700 }}>
                                            目前為編輯模式；完成後請按「儲存變更」，或按「取消編輯」放棄尚未儲存的修改。
                                        </Typography>
                                    )}
                                    <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}> {/* gap 設置按鈕間距 */}
                                        {isCreate && (
                                            <Button variant="contained" onClick={handleSave} disabled={['Pending', 'Approved', 'Cancelled', 'Legacy'].includes(detailData?.approvalStatus)}>
                                                {detailData?.toShipNum ? '儲存變更' : '儲存草稿'}
                                            </Button>
                                        )}
                                        {!isCreate && detailData?.toShipNum && (
                                            <Button variant="contained" onClick={handleEnterEdit} disabled={['Pending', 'Approved', 'Cancelled', 'Legacy'].includes(detailData?.approvalStatus)}>
                                                進入編輯
                                            </Button>
                                        )}
                                        {isExistingEditMode && (
                                            <Button variant="outlined" color="warning" onClick={handleCancelEdit} disabled={loading}>
                                                取消編輯
                                            </Button>
                                        )}
                                        <Button variant="contained" color="info" onClick={() => handleApprovalAction('SubmitApproval')} disabled={!detailData?.toShipNum || !['Draft', 'Rejected'].includes(detailData?.approvalStatus || 'Draft')}>送審</Button>
                                        <Button variant="contained" color="success" onClick={() => handleApprovalAction('Approve')} disabled={detailData?.approvalStatus !== 'Pending'}>核准扣帳</Button>
                                        <Button variant="contained" color="warning" onClick={() => handleApprovalAction('Reject')} disabled={detailData?.approvalStatus !== 'Pending'}>退回</Button>
                                        <Button variant="contained" color="error" onClick={() => handleApprovalAction('CancelApproval')} disabled={detailData?.approvalStatus !== 'Approved'}>取消並沖回</Button>
                                        <Button variant="contained" color="warning" onClick={checkSupplement} disabled={loading || isCreate || supplementSelection.length === 0}>查核選取明細補扣帳</Button>
                                        {!isCreate && <ShipmentAdjustments shipNum={detailData?.toShipNum}
                                            selectedRows={rows.filter(x => supplementSelection.includes(x.id))}
                                            onComplete={() => refreshDetailsByNum(detailData.toShipNum, selectedOption?.manufacturer_AbbreviationName)} />}
                                        <Button variant="outlined" onClick={loadPostingResults} disabled={!detailData?.toShipNum}>過帳結果</Button>
                                        <Button variant="contained" onClick={() => handlePrint(detailData.toShipNum)}>列印</Button>
                                        <Button variant="contained" onClick={() => handleExecl(detailData.toShipNum)}>Excel</Button>
                                        <Button variant="contained" onClick={() => handleAccountSharing(selectedRow)} disabled={['Pending', 'Approved', 'Cancelled', 'Legacy'].includes(detailData?.approvalStatus)}>分拆</Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box sx={{ height: 450, width: '100%' }}>
                            <DataGrid
                                ref={gridRef}
                                rows={isCreate ? createRows : rows}
                                checkboxSelection={!isCreate}
                                rowSelectionModel={supplementSelection}
                                onRowSelectionModelChange={(ids) => setSupplementSelection(ids)}
                                columns={!isCreate ? columns : orderColumns}
                                onRowClick={(params) => setSelectedRow(params.row)} // 設置選中的行數據
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 100,
                                        },
                                    },
                                }}
                                rowHeight={32}
                                headerHeight={35} 
                                processRowUpdate={processRowUpdate}
                                onProcessRowUpdateError={error => alert(error)}
                                // 修正 onRowEditCommit
                                pageSizeOptions={[100]}
                                disableRowSelectionOnClick
                                sx={{
                                    '& .MuiDataGrid-cell': { fontSize: 15 },
                                    '& .MuiDataGrid-columnHeaders': { fontSize: 15 },
                                    '& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader': {
                                      paddingTop: '4px', paddingBottom: '4px'
                                    },
                                  }}
                            />
                        </Box>
                        <Box sx={{ height: 600, width: '100%' }}>
                            <Box sx={{ flexGrow: 1 }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <FormControl>
                                            <FormLabel id="demo-row-radio-buttons-group-label">未出貨訂單</FormLabel>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                value={way}
                                                onChange={(e) => setWay(e.target.value)}
                                            >
                                                <FormControlLabel value="orderNum" control={<Radio />} label="訂單號碼" />
                                                <FormControlLabel value="drawNum" control={<Radio />} label="圖號" />
                                                <FormControlLabel value="piNum" control={<Radio />} label="批號" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                        <TextField id="outlined-basic" label="圖號" variant="outlined"
                                            value={num} onChange={(e) => setNum(e.target.value)} />
                                        <Button variant="contained" color="secondary" onClick={handleSupplementSubmit}>補交</Button>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField id="outlined-basic" label="條碼" variant="outlined"
                                            value={barCode} onChange={(e) => setBarCode(e.target.value)} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Button variant="contained" onClick={fetchOrders}>搜尋</Button>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ height: 450, width: '100%' }}>
                                <DataGrid
                                    ref={gridRef}
                                    rows={orderRows}
                                    columns={orderColumnsNoEdit}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 100,
                                            },
                                        },
                                    }}
                                    rowHeight={32}
                                    headerHeight={35} 
                                    onRowDoubleClick={handleAddToShip}
                                    pageSizeOptions={[100]}
                                    disableRowSelectionOnClick
                                    sx={{
                                        '& .MuiDataGrid-cell': { fontSize: 15 },
                                        '& .MuiDataGrid-columnHeaders': { fontSize: 15 },
                                        '& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader': {
                                          paddingTop: '4px', paddingBottom: '4px'
                                        },
                                      }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </div>
                <div className='col-1' />
                </div>

                {/* 分拆對話框 */}
                <Dialog open={splitDialogOpen} onClose={handleDialogClose}>
                    <DialogTitle>分拆訂單</DialogTitle>
                        <DialogContent>
                            <TextField
                            label="分拆數量"
                            type="number"
                            value={splitQuantity}
                            onChange={(e) => setSplitQuantity(Number(e.target.value))}
                            fullWidth
                            margin="dense"
                        />
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleDialogClose}>取消</Button>
                <Button onClick={handleSplitSubmit} variant="contained">提交</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={postingDialogOpen} onClose={() => setPostingDialogOpen(false)} fullWidth maxWidth="lg">
                <DialogTitle>出貨過帳結果－{detailData?.toShipNum}</DialogTitle>
                <DialogContent>
                    <Box sx={{ height: 420, mt: 1 }}>
                        <DataGrid
                            rows={postingResults.map((row, index) => ({ ...row, id: row.sourceLineId || index + 1 }))}
                            columns={[
                                { field: 'drawNum', headerName: '圖號', width: 160, renderCell: (params) => <Button onClick={() => openRecentMaterialCards(params.value)}>{params.value}</Button> },
                                { field: 'batchNo', headerName: '批號', width: 140 },
                                { field: 'postedQuantity', headerName: '過帳數量', width: 110 },
                                { field: 'beforeStock', headerName: '過帳前庫存', width: 120 },
                                { field: 'afterStock', headerName: '過帳後庫存', width: 120 },
                                { field: 'status', headerName: '狀態', width: 100 },
                                { field: 'message', headerName: '說明', flex: 1, minWidth: 220 }
                            ]}
                            getRowClassName={(params) => params.row.status === 'Unposted' ? 'posting-error' : ''}
                            sx={{ '& .posting-error': { color: '#d32f2f', bgcolor: '#ffebee' } }}
                            disableRowSelectionOnClick
                        />
                    </Box>
                </DialogContent>
                <DialogActions><Button onClick={() => setPostingDialogOpen(false)}>關閉</Button></DialogActions>
            </Dialog>
            <Dialog open={supplementOpen} onClose={() => !loading && setSupplementOpen(false)} fullWidth maxWidth="lg">
                <DialogTitle>選取明細補扣查核－{detailData?.toShipNum}</DialogTitle>
                <DialogContent>
                    <Typography sx={{ mb: 1 }}>已扣足或待確認的明細不可補扣；請關閉後重新勾選可補扣明細。</Typography>
                    <Box sx={{ height: 350 }}>
                        <DataGrid rows={supplementChecks} getRowId={(row) => row.lineId} columns={[
                            { field: 'drawNum', headerName: '圖號', width: 150 },
                            { field: 'batchNo', headerName: '批號', width: 140 },
                            { field: 'shipmentQuantity', headerName: '出貨數量', width: 100 },
                            { field: 'postedQuantity', headerName: '已扣數量', width: 100 },
                            { field: 'supplementQuantity', headerName: '補扣數量', width: 100 },
                            { field: 'afterStock', headerName: '預計庫存', width: 100 },
                            { field: 'status', headerName: '查核狀態', width: 110 },
                            { field: 'message', headerName: '說明', minWidth: 260, flex: 1 }
                        ]} disableRowSelectionOnClick />
                    </Box>
                    <TextField fullWidth sx={{ mt: 2 }} label="補扣原因（最多20字）" value={supplementReason}
                        inputProps={{ maxLength: 20 }} onChange={(e) => setSupplementReason(e.target.value)} />
                </DialogContent>
                <DialogActions>
                    <Button disabled={loading} onClick={() => setSupplementOpen(false)}>關閉</Button>
                    <Button variant="contained" disabled={loading || !supplementReason.trim() || supplementChecks.length === 0 || supplementChecks.some(x => x.status !== '可補扣')}
                        onClick={executeSupplement}>確認補扣（需核准權限）</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={recentCardDialogOpen} onClose={() => setRecentCardDialogOpen(false)} fullWidth maxWidth="lg">
                <DialogTitle>{recentCardDrawNum}－最近兩個月資材卡（日期由新到舊）</DialogTitle>
                <DialogContent>
                    <Box sx={{ height: 430, mt: 1 }}>
                        <DataGrid
                            rows={recentCards.map((row, index) => ({ ...row, id: row.id || index + 1 }))}
                            columns={[
                                { field: 'date', headerName: '日期', width: 115 },
                                { field: 'kind', headerName: '類別', width: 120 },
                                { field: 'orderNum', headerName: '單號', width: 135 },
                                { field: 'piNum', headerName: '批號', width: 140 },
                                { field: 'inAmount', headerName: '入量', width: 90 },
                                { field: 'outAmount', headerName: '出量', width: 90 },
                                { field: 'stock', headerName: '庫存量', width: 100 },
                                { field: 'approve', headerName: '核准', width: 100 },
                                { field: 'receive', headerName: '領用', width: 100 }
                            ]}
                            disableRowSelectionOnClick
                        />
                    </Box>
                </DialogContent>
                <DialogActions><Button onClick={() => setRecentCardDialogOpen(false)}>關閉</Button></DialogActions>
            </Dialog>
            <Dialog open={deleteDialogOpen} onClose={handleCancelDelete}>
    <DialogTitle>確認刪除</DialogTitle>
    <DialogContent>
        {rowToDelete && (
            <>
                <div>確定要刪除這筆資料嗎？</div>
                <div>批號：<b>{rowToDelete.批號}</b></div>
                <div>實交貨數：<b>{rowToDelete.實交貨數}</b></div>
                <div>訂單號碼：<b>{rowToDelete.訂單號碼} + {rowToDelete.流水號}</b></div>
            </>
        )}
    </DialogContent>
    <DialogActions>
        <Button onClick={handleCancelDelete}>取消</Button>
        <Button onClick={handleConfirmDelete} color="error" variant="contained">確認刪除</Button>
    </DialogActions>
</Dialog>

        </div>
        </>
    );
}

function ListTable({ data, onOpenDetails, setNewData, setRows, setDetailData, page, setPage, setComs, setSelectedDate, setSelectedDrDate, setIsCreate, options, setSelectedOption, month,setLoading,filterClient,
    filterShipNum }) {
    const thStyle = {
        centered: {
            textAlign: 'center',
        }
    };
    const btnPageMargin = {
        marginLeft: '2%',
        marginRight: '2%',
    };

    const fetchCom = async (client) => {
        setLoading(true);
        try {
            const response = await apiClient.get(`/ToShip/Comlist?com=${client}`);
            // 檢查響應的結果，並設置到 state
            if (response.status === 200) {
                setComs(response.data);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }finally{
            setLoading(false);
        }
    };

    const nextPage = async () => {
        setLoading(true);
        console.log("月份", month);
      
        try {
          const { data } = await apiClient.get(`/ToShip/GetMains`, {
            params: {
              month,
              client: filterClient,       // ✅ 使用從父層傳進來的條件
                toShipNum: filterShipNum,   // ✅ 同上
              page: page + 1,
            },
          });
      
          if (data.statusCode === 200) {
            setNewData(data);
            setPage(page + 1);
          } else {
            alert(data.message || "已經是最後一筆了");
          }
        } catch (error) {
          console.log(error);
          alert(error.response?.data?.message || "查詢失敗");
        } finally {
          setLoading(false);
        }
      };
      

      const prePage = async () => {
        if (page === 1) return;
      
        setLoading(true);
        console.log("月份", month);
      
        try {
          const { data } = await apiClient.get(`/ToShip/GetMains`, {
            params: {
              month,
              client: filterClient,
              toShipNum: filterShipNum,
              page: page - 1,
            },
          });
      
          if (data.statusCode === 200) {
            setNewData(data);
            setPage(page - 1);
          }
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      };
      

 

    return (
        <>
            <div style={{ overflow: 'auto', maxHeight: '500px', width: '100%' }}> {/* 縮小表格顯示範圍 */}
                <table className="table" style={{ width: '100%' }}> {/* 限制表格寬度 */}
                    <thead>
                        <tr>
                            <th scope="col" style={{ textAlign: 'center', width: '10%' }}>#</th>
                            <th scope="col" style={{ textAlign: 'center', width: '30%' }}>出貨單號</th>
                            <th scope="col" style={{ textAlign: 'center', width: '30%' }}>客戶</th>
                            <th scope="col" style={{ textAlign: 'center', width: '30%' }}>操作</th>
                        </tr>
                    </thead>
                <tbody>
                    {data.toShips.map((item, index) => (
                        <tr key={item.id}>
                            <th scope="row" style={{ textAlign: 'center' }}>{index + 1}</th>
                            <td style={{ textAlign: 'center' }}>{item.toShipNum}</td>
                            <td style={{ textAlign: 'center' }}>{item.client}</td>
                            <td style={{ textAlign: 'center' }}>
                            <Button variant="contained" color="warning" onClick={() => onOpenDetails(item.toShipNum, item.client)}>詳細</Button>
                            </td>
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div style={{ textAlign: 'center' }} className='mt-3'>
                <button type="button" style={btnPageMargin} className="btn btn-dark" onClick={() => prePage()} disabled={page === 1}>上一頁</button>
                <span style={{ margin: '0 10px' }}>目前在第{page}頁</span>
                <button type="button" style={btnPageMargin} className="btn btn-dark" onClick={() => nextPage()}>下一頁</button>
            </div>
        </>
    );
}

function SelectFilter({setNewData,setMonth,setLoading,filterClient,setFilterClient,filterShipNum,setFilterShipNum,
  }) {
        const [open, setOpen] = useState(false);
        // 一開始不要預設日期 → 用 null
        const [localMonth, setLocalMonth] = useState(null);
    const [client, setClient] = useState('');
    const [shipNum, setShipNum] = useState(''); // 新增出貨單號

    // 點擊搜尋按鈕打開 Dialog
    const handleOpen = () => setOpen(true);

    // 取消關閉 Dialog
    const handleClose = () => setOpen(false);

    // 跟原本 handleSubmit 一樣
    const handleDialogSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        const dateStr = localMonth ? dayjs(localMonth).format('YYYY/MM/DD') : '';
        setMonth(dateStr);

        const page = 1;
        const Realapiurl = `/ToShip/GetMains`;
        const params = {
            month: dateStr,
            client: filterClient,
            toShipNum: filterShipNum,
            page,
        };

        try {
            const { data } = await apiClient.get(Realapiurl, { params });

            // 後端 ToShipResponse 通常會有 statusCode / message
            if (data.statusCode !== 200) {
            alert(data.message || '查詢失敗');
            return;
            }
            // ✅ 成功才真的覆蓋左邊列表用的資料
            setNewData(data);
            setOpen(false); // 查詢成功就關掉 Dialog
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* 只有這一顆按鈕一開始顯示 */}
            <Button variant="contained" color="primary" onClick={handleOpen}>
                搜尋
            </Button>
            <Dialog open={open} onClose={handleClose}>
                <form onSubmit={handleDialogSubmit}>
                    <DialogTitle>查詢條件</DialogTitle>
                    <DialogContent>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="日期（可留空）"
                            value={localMonth}
                            onChange={(newValue) => setLocalMonth(newValue)}
                            sx={{ mb: 2, width: '100%' }}
                            slotProps={{
                            textField: {
                                fullWidth: true,
                                placeholder: '不選日期 = 不限制；選任一天 = 查該月份',
                                helperText: '不選日期就查全部，選擇任一天系統會用該月作為查詢條件',
                            },
                            }}
                        />

                        </LocalizationProvider>
                        <TextField
                            label="客戶"
                            value={filterClient}
                            onChange={(e) => setFilterClient(e.target.value)}
                            margin="dense"
                            fullWidth
                        />
                        <TextField
                            label="出貨單號"
                            value={filterShipNum}
                            onChange={(e) => setFilterShipNum(e.target.value)}
                            margin="dense"
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>取消</Button>
                        <Button type="submit" variant="contained" color="primary">提交</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}
